export const loadGoogleTagManager = (lazyLoad?: boolean) => {
  const injectScript = () => {
    if (typeof window !== 'undefined') {
      (function (w, d, s, l, i) {
        // @ts-ignore
        w[l] = w[l] || [];
        // @ts-ignore
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js',
        });
        const f = d.getElementsByTagName(s)[0],
          j = d.createElement(s) as HTMLScriptElement,
          dl = l !== 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
        // @ts-ignore
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-MSX7NS');
    }
  };

  if (lazyLoad) {
    window.addEventListener('load', injectScript);
  } else {
    injectScript();
  }
};
